import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
// import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';

const LastStories = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        flexDirection={{ xs: 'column', sm: 'row' }}
      >
        <Box>
          {/* <Typography fontWeight={700} variant={'h4'} gutterBottom>
          OUR CAMPUS
          </Typography> */}
          <Typography variant={'h6'}></Typography>
        </Box>
        <Box display="flex" marginTop={{ xs: 2, md: 0 }}>
          {/* <Button variant="contained" color="primary" size="large">
            Apply now
          </Button> */}
          {/* <Box
            component={Button}
            variant="outlined"
            color="primary"
            size="large"
            marginLeft={2}
          >
            Refer a friend
          </Box> */}
        </Box>
      </Box>
      <Divider sx={{ marginY: 4 }} />
      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} md={8}>
          <Box marginBottom={3}>
            <Typography variant={'h5'} fontWeight={700} gutterBottom>
            Classrooms
            </Typography>
            <Typography component={'p'}>
            The classrooms are large and well ventilated with white/green boards and bulletin boards inside and outside the classrooms.
            Strength of each class is kept at manageable level with comfortable furniture which adds to the ambience of the class room.
            </Typography>
            <Typography variant={'h5'} fontWeight={700} gutterBottom>
            Computer Lab
            </Typography>
            <Typography component={'p'}>
            A computer lab with internet connection to source the websites for educational material.
           Computer classes start from Grade 1 onwards. Internet can be accessed by students in presence of a teacher only.
            </Typography>
            <Typography variant={'h5'} fontWeight={700} gutterBottom>
            Science Lab
            </Typography>
            <Typography component={'p'}>
            Labs are especially designed for the students to get hands on experience in science and to make learning fun.
            </Typography>
            <Typography variant={'h5'} fontWeight={700} gutterBottom>
            Maths Lab
            </Typography>
            <Typography component={'p'}>
            A well equipped maths lab provides the students with the opportunity to have fun with numbers. It helps the students to put their mathematical abilities to test and enhance their analytical reasoning and lateral thinking through various models, games and activities.
            </Typography>
            <Typography variant={'h5'} fontWeight={700} gutterBottom>
            Library / Media Centre
            </Typography>
            <Typography component={'p'}>
            Library is the main resource of centre in NPS, Yeshwanthpur.
It has a seating capacity of 200 students.
It mainly contains text books, reference books, fiction titles, periodicals, audio visual material like CD and VCD’s and teaching resources.
There is a special reading programme which encourages the children to read the recommended library books.
            </Typography>
          </Box>
          <Box marginBottom={3}>
            <Typography variant={'h5'} fontWeight={700} gutterBottom>
            The other facilities available are :

            </Typography>
            <Grid container spacing={1} sx={{ marginTop: 1 }}>
              {[
                'Art and Craft Room',
                'Audio Visual Room',
                'Auditorium',
                'Activity Room',
                'Conference Room',
                'Counselling Centre',
                'Dance Room',
                'Health Centre',
                'Music Room',
                'Resource Room',

              ].map((item, i) => (
                <Grid item xs={12} key={i}>
                  <Box
                    component={ListItem}
                    disableGutters
                    width={'auto'}
                    padding={0}
                  >
                    <Box
                      component={ListItemAvatar}
                      minWidth={'auto !important'}
                      marginRight={2}
                    >
                      <Box
                        component={Avatar}
                        bgcolor={theme.palette.secondary.main}
                        width={20}
                        height={20}
                      >
                        <svg
                          width={12}
                          height={12}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </Box>
                    </Box>
                    <ListItemText primary={item} />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
          {/* <Box>
            <Typography variant={'h5'} fontWeight={700} gutterBottom>
              Why to apply
            </Typography>
            <Typography component={'p'}>
              We believe lorem ipsum dolor sit amet, consectetur adipiscing
              elit. Phasellus feugiat elit vitae enim lacinia semper. Cras nulla
              lectus, porttitor vitae urna iaculis, malesuada tincidunt lectus.
              Proin nec tellus sit amet massa auctor imperdiet id vitae diam.
              Aenean gravida est nec diam suscipit iaculis. Praesent urna velit,
              auctor nec turpis et, vehicula lobortis sem. Vivamus convallis mi
              sagittis eleifend laoreet. Praesent vitae venenatis enim. Nulla
              tincidunt felis et lectus rhoncus laoreet.
            </Typography>
          </Box> */}
        </Grid>
        <Grid item xs={12} md={4}>
          <Grid container spacing={isMd ? 4 : 2} direction="column">
            <Grid item xs={12} data-aos="fade-up">
              <Box component={Card} bgcolor={'primary.main'}>
                <CardContent>
                  <Typography
                    variant="h6"
                    gutterBottom
                    color="text.primary"
                    sx={{ color: 'common.white' }}
                  >
                  NATIONAL PUBLIC SCHOOL
               No. 9/1, Pipeline Road, Raghavendra Layout,
Yeshwanthpur, Bengaluru —560-022
                  </Typography>
                  {/* <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    sx={{ color: 'common.white' }}
                  >
                    +91 80 23571220
                    +91 80 29501184
                    +91 6364071122
                  </Typography> */}
                </CardContent>
              </Box>
            </Grid>
            <Grid item xs={12} data-aos="fade-up">
              <Box component={Card}>
                <CardContent>
                  {<Typography variant="h6" gutterBottom color="text.primary">
                  +91 80 23571220
                  +91 80 29501184
                  +91 6364071122
                  </Typography> }
                  {<Typography variant="h6" gutterBottom color="text.primary">
                  info@npsypr.edu.in
                  admissions@npsypr.edu.in
                  accounts@npsypr.edu.in
                  procurement@npsypr.edu.in
                  </Typography> }
                  
                  {/* <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    endIcon={
                      <Box
                        component={'svg'}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        width={24}
                        height={24}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 8l4 4m0 0l-4 4m4-4H3"
                        />
                      </Box>
                    }
                  >
                    View all
                  </Button> */}
                </CardContent>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LastStories;